import { getAppBase } from './appBase.js';

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  const swUrl = `${getAppBase()}sw.js`.replace(/\/{2,}/g, '/');

  window.addEventListener('load', () => {
    navigator.serviceWorker.register(swUrl, { scope: getAppBase() }).catch((err) => {
      console.warn('[PWA] service worker:', err);
    });
  });
}

export function injectPwaMeta() {
  const base = getAppBase();

  if (!document.querySelector('link[rel="manifest"]')) {
    const manifest = document.createElement('link');
    manifest.rel = 'manifest';
    manifest.href = `${base}manifest.webmanifest`;
    document.head.appendChild(manifest);
  }

  const ensureMeta = (name, content) => {
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
      el = document.createElement('meta');
      el.name = name;
      document.head.appendChild(el);
    }
    el.content = content;
  };

  ensureMeta('theme-color', '#2a1218');
  ensureMeta('mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-capable', 'yes');
  ensureMeta('apple-mobile-web-app-status-bar-style', 'black-translucent');
  ensureMeta('apple-mobile-web-app-title', 'Arcade Retro');

  if (!document.querySelector('link[rel="apple-touch-icon"]')) {
    const icon = document.createElement('link');
    icon.rel = 'apple-touch-icon';
    icon.href = `${base}icons/icon-192.png`;
    document.head.appendChild(icon);
  }
}

export function isStandaloneApp() {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    window.matchMedia('(display-mode: fullscreen)').matches ||
    Boolean(window.navigator.standalone)
  );
}

export function isAndroid() {
  return /android/i.test(navigator.userAgent);
}

export function isIos() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent);
}
